import {useState} from "react";
import { INews } from "../../news/logics/news";
import { empty } from "../../../common/functions";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";

interface INewsItem {
  newsItem: INews;
  important?: boolean;
  pinned?: boolean;
}

export const NewsItem = ({
  newsItem,
  important = false,
  pinned = false,
}: INewsItem) => {
  const [showUrl, setShowUrl] = useState(false); //состояние, указывающее на то, показываться ли список аакаунтов полностью
  const onShowNewsClicked = () => {
    if (!showUrl)
      if (empty(newsItem.url)) {
        toast.info("Содержимое новости не обнаружено");
        return;
      }
    setShowUrl(!showUrl);
  };
  let text = newsItem.notice;
  if (text.length > 210) {
    text = text.substr(0, 210);
    let spaceIdx = text.lastIndexOf(" ");

    //! Обрати внимание, ругался тайпскрипт. Прошлый код в комменте

    if (spaceIdx !== -1) text = text.substr(0, spaceIdx + 1) + "...";
    else spaceIdx = 1;
    // spaceIdx !== -1 ? (text = text.substr(0, spaceIdx + 1) + "...") : 1
  }
  const dt = new Date(newsItem.created);
  const divStyle = {
    borderLeft: "15px solid " + (important ? "#EC607E" : "white"),
  };

  return (
    <div style={divStyle} className="page__data-card" id={"rt" + newsItem.id}>
      {showUrl ? (
        <div style={{ width: "100%", height: "400px" }} className="sc-st">
          <object
            type="text/html"
            data={"https://izba.kras-abs.ru/" + newsItem.url}
            style={{ width: "100%", height: "100%" }}
            aria-label="Новость"
          ></object>
        </div>
      ) : (
        <>
          <h2 className="news-card__title">{newsItem.title}</h2>
          <p className="news-card__text">{text}</p>
        </>
      )}
      <div className="row col-12 m-0 p-0 pt-2">
        <div className="mr-auto text-muted">
          {!isNaN(dt.getTime()) ? dt.toLocaleDateString() : ""}
        </div>
        <Button
          variant="link"
          className="pt-0 text-muted cp shadow-none ml-auto"
          onClick={() => onShowNewsClicked()}
        >
          <u>{showUrl ? "Скрыть" : "Подробнее"}</u>
        </Button>
      </div>
    </div>
  );
};
